import { ActionTree } from 'vuex';
import { RootState } from '../../types';
import { TrainerHoursState } from './types';
import { Logger } from 'fsts';
import { defaultBackendTrainerHours } from '@/shared/backend/trainerHours';
import moduleUtils from '../moduleUtils';
import { i18nGlobal } from '@/i18n';
import {
  TrainerHours,
  TrainerHoursStatusEnum,
} from '@/shared/model/trainerHours';
import DownloadUtils from '@/shared/utils/downloadUtils';

const logger = new Logger('actions.trainerHours');
export const actions: ActionTree<TrainerHoursState, RootState> = {
  getTrainerHours(
    { commit, getters },
    payload: {
      searchParams?: any;
      trainerId: string;
      minDate?: string;
      maxDate?: string;
      courseId?: string | null;
      costCenter?: string;
      locationId?: string;
      departmentId?: string;
    }
  ) {
    commit('setTrainerHoursIsLoading', true);
    const searchParams =
      payload?.searchParams ?? getters.getTrainerHoursSearchParams;

    return defaultBackendTrainerHours
      .getTrainerHours(
        searchParams,
        payload.trainerId,
        payload.minDate,
        payload.maxDate,
        payload.courseId,
        payload.costCenter,
        payload.departmentId,
        payload.locationId
      )
      .then((resp) => {
        commit('setTrainerHours', resp.data);
        return resp.data;
      })
      .catch((err) => {
        moduleUtils.error('error', commit, err, logger);
        throw err;
      })
      .finally(() => {
        commit('setTrainerHoursIsLoading', false);
      });
  },
  updateTrainerHours({ commit }, trainerHours: TrainerHours) {
    return defaultBackendTrainerHours
      .updateTrainerHours(trainerHours)
      .then((resp) => {
        moduleUtils.ok(i18nGlobal.t(`success.trainer_hours_update`), commit);
        return resp.data;
      })
      .catch((err: any) => {
        moduleUtils.error('error', commit, err, logger);
        throw err;
      });
  },
  addTrainerHoursByAttendances({ commit }, attendanceIds: string[]) {
    return defaultBackendTrainerHours
      .addTrainerHoursByAttendances(attendanceIds)
      .catch((err: any) => {
        moduleUtils.error('error', commit, err, logger);
        throw err;
      });
  },
  getTrainerHoursFeeSums(
    { commit },
    payload: { trainerId: string; year: number }
  ) {
    return defaultBackendTrainerHours
      .getTrainerHoursFeeSums(payload.trainerId, payload.year)
      .then((resp) => {
        return resp.data;
      })
      .catch((err: any) => {
        moduleUtils.error('error', commit, err, logger);
        throw err;
      });
  },
  deleteTrainerHours({ commit }, id: string) {
    return defaultBackendTrainerHours
      .deleteTrainerHours(id)
      .then((resp) => {
        moduleUtils.ok(i18nGlobal.t(`success.trainer_hours_deletion`), commit);
        return resp.data;
      })
      .catch((err: any) => {
        moduleUtils.error('error', commit, err, logger);
        throw err;
      });
  },
  exportTrainerHours(
    { commit },
    payload: {
      year?: number;
      months?: number[];
      trainerId?: string;
      statuses?: TrainerHoursStatusEnum[];
    }
  ) {
    commit('setTrainerHoursIsLoading', true);
    const lang = i18nGlobal.locale.value;
    return defaultBackendTrainerHours
      .exportTrainerHours(
        payload.trainerId,
        payload.year,
        payload.months,
        payload.statuses,
        lang
      )
      .then(DownloadUtils.openDownloadedFileInBrowser)
      .catch((err) => {
        moduleUtils.error('error', commit, err, logger);
        throw err;
      })
      .finally(() => {
        commit('setTrainerHoursIsLoading', false);
      });
  },
};
